import type { TaskElement } from "./schema";
import { BaseElementProvider, ElementProps, ToolbarProps } from "elements/base/provider";
import type { ElementController } from "elements/base/controller";
import React from "react";
import consts, { TypeCanvasElement } from "shared/consts";
import type { BoardContext } from "elements/index";
import TaskController from "./controller";
import TaskToolbar from "./toolbar/task-toolbar";
import TaskElementComponent from "./components/task-component";

export default class TaskElementProvider extends BaseElementProvider<TaskElement> {
  getType(): TypeCanvasElement {
    return consts.CANVAS_ELEMENTS.TASK;
  }

  getElementRenderer(): React.FC<ElementProps<TaskElement>> {
    return TaskElementComponent;
  }

  getToolbarRenderer(): React.FC<ToolbarProps<TaskElement>> {
    return TaskToolbar;
  }

  createController(
    id: string,
    element: TaskElement,
    context: BoardContext,
    _allElementsData: [string, any][] = []
  ): ElementController<TaskElement> {
    return new TaskController(id, element, context);
  }

  isConnectorsEnabled(): boolean {
    return true;
  }

  isVotingEnabled(): boolean {
    return true;
  }

  isFFEnabled(): boolean {
    return true;
  }

  isLinkBadgeEnabled(): boolean {
    return true;
  }

  isTableSupported(): boolean {
    return true;
  }
}
